import request from '@/utils/request'


// 查询特殊起订价列表
export function listSpecialMinimum(query) {
  return request({
    url: '/user/special-minimum/list',
    method: 'get',
    params: query
  })
}

// 查询特殊起订价分页
export function pageSpecialMinimum(query) {
  return request({
    url: '/user/special-minimum/page',
    method: 'get',
    params: query
  })
}

// 查询特殊起订价详细
export function getSpecialMinimum(data) {
  return request({
    url: '/user/special-minimum/detail',
    method: 'get',
    params: data
  })
}

// 新增特殊起订价
export function addSpecialMinimum(data) {
  return request({
    url: '/user/special-minimum/add',
    method: 'post',
    data: data
  })
}

// 修改特殊起订价
export function updateSpecialMinimum(data) {
  return request({
    url: '/user/special-minimum/edit',
    method: 'post',
    data: data
  })
}

// 删除特殊起订价
export function delSpecialMinimum(data) {
  return request({
    url: '/user/special-minimum/delete',
    method: 'post',
    data: data
  })
}
